import { store } from '@/store';

const isFavourite = (resourceId, type) => {
  const favourites = store.getters.getFavourites || [];
  return favourites.some((favourite) => {
    if (!favourite) return false;
    if (favourite?.resource_id === resourceId && favourite?.resource_type === type) return true;
    if (favourite?.children) {
      return favourite.children.some(
        (child) => child?.resource_id === resourceId && child?.resource_type === type
      );
    }
    return false;
  });
};

export default isFavourite;
